@if (dataForCard && dataForCard.length > 0) {
  @for (data of dataForCard; track data) {
    <div>
      <!-- <div class="kx-relative float-right" *ngIf="data.buttonConfig && data.buttonConfig.config.buttonMenu && data.buttonConfig.config.type == 'ellipse'">
      <i class="fa fa-ellipsis-v clickable kx-table-three-dots" data-toggle="dropdown" aria-hidden="true" *ngIf="checkEllipseMenu(data.buttonConfig)"></i>
      <div class="dropdown-menu three-dots-menu" role="menu" tabindex="-1" x-placement="bottom-start">
        <span *ngFor="let action of data.buttonConfig.config.buttonMenu let i = index">
          <button class="dropdown-item cursorSpanEllipse" (click)="emitEllipseId(data,action)"
            *ngIf="!action.button">
            <i class="fa {{action.icon}}" aria-hidden="true">&nbsp;</i>{{action.label}}
          </button>
        </span>
      </div>
    </div> -->
    <!-- {{fields.name}}{{fields.order}} -->
    @if (data.image) {
      <div [ngClass]="data.image.className">
        <img alt="" class="" id="" src="./assets/images/user-profile-image.png">
      </div>
    }
    @if (data.fields) {
      <div class="card-fields mt-2">
        @for (fields of data.fields; track fields) {
          @if (fields.value != undefined) {
            <div  [ngClass]="fields.className">
              @if (fields.showheading) {
                <span class="text-capitalize">
                  <b>{{fields.heading | translate | async}}</b>
                </span>
              }
              @if (fields.value != undefined && fields.type==undefined) {
                <span class="text-capitalize" id="{{fields.name}}{{fields.order}}">
                  {{fields.value}}
                </span>
              }
              @if (fields.value != undefined && fields.type=='composite') {
                <span class="text-capitalize" id="{{fields.name}}{{fields.order}}">
                  {{fields.value}}
                </span>
              }
              @if (fields.value != undefined && fields.type === 'datetime') {
                <span>
                  {{ fields.value ? (fields.value | dateTimeFormat) : ''}}
                </span>
              }
            </div>
          }
        }
      </div>
    }
    <div class="card-other-services">
      <div class="col-12">
        @if (data.vip) {
          <img src="assets/images/VIP.png" class="patient-status-images">
        }
        @if (data.vulnerable) {
          <img src="assets/images/Vulnerable.png" class="patient-status-images">
        }
        @if (data.handleWithCare) {
          <img src="assets/images/HandleWithCare.png" class="patient-status-images">
        }
        @if (data.complexDiagnosis) {
          <img src="assets/images/ComplexCare.png" class="patient-status-images">
        }
        @if (data.mlc) {
          <i class="fa fa-low-vision" aria-hidden="true"></i>
        }
      </div>
    </div>
    <!-- <ng-container *ngIf="data.hasOwnProperty('buttonConfig')">
    <div *ngIf="data.buttonConfig.hasOwnProperty('config')">
      <div *ngIf="data.buttonConfig.config.hasOwnProperty('footerLinks')" class="card-other-services">
        <span class="pull-right" *ngFor="let link of data.buttonConfig.config.footerLinks;">
          <a style="cursor: pointer; text-decoration: none; color: #20a8d8; padding-right: 5px;"
          (click)="cardFooterLinksClick(link)">{{link.label}} </a>
        </span>
      </div>
    </div>
  </ng-container> -->
</div>
}
}